import React from "react";
import {
  Card,
  Column,
  Columns,
  Divider,
  Heading,
  List,
  ListItem,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { IconLocalOffer } from "@origin-digital/ods-icons";
import content from "./content.json";
import { formatCurrencyAndRoundUp } from "../../utils/formatter";
import { ILPGOffer } from "../../model/ILPGOffer";

export const Cart = ({ offer }: { offer: ILPGOffer }) => {
  return (
    <Card data-id="my-cart">
      <Stack space={["medium", "large"]}>
        <Stack space={["small", "medium"]}>
          <Columns alignY="center">
            <Column width="content">
              <Heading variant="h3">{content.selection}</Heading>
            </Column>
          </Columns>
        </Stack>
        <Divider />

        <Stack space={["xxsmall", "xsmall"]}>
          <Columns>
            <Column>
              <Stack alignX="left" space="xxsmall">
                <Text
                  variant="subtitle-small"
                  weight="medium"
                  tone="neutral"
                  data-id="my-cart-offer"
                >
                  {offer.offerName}
                </Text>
                <Text
                  variant="body-small"
                  weight="regular"
                  data-id="my-cart-price-description"
                >
                  {offer.priceDescription}
                </Text>
              </Stack>
            </Column>
            <Column alignX="right" width="content">
              <Stack alignX="right" space="xxsmall">
                <Text
                  variant="subtitle-small"
                  weight="medium"
                  tone="neutral"
                  data-id="my-cart-price"
                >
                  $
                  {offer.bottlePricing?.["1"] &&
                    formatCurrencyAndRoundUp(offer.bottlePricing?.["1"].price)}
                </Text>
                <Text variant="body-small" weight="regular" tone="neutral">
                  {content.offerPriceQualifier}
                </Text>
              </Stack>
            </Column>
          </Columns>
        </Stack>
        <List variant="body" space="xxsmall">
          {offer.offerAdditionalInformation.map((offerTerm, index) => (
            <ListItem key={index} data-id="my-cart-additional-information">
              {offerTerm}
            </ListItem>
          ))}
        </List>
        {offer.bonusBox && (
          <List variant="body" space="small" data-id="my-cart-offer-bonus">
            <ListItem
              icon={
                // @ts-ignore
                <IconLocalOffer tone={offer.offerColour} />
              }
            >
              {offer.bonusBox}
            </ListItem>
          </List>
        )}
        <Divider />
        <Stack space={["xxsmall", "xsmall"]}>
          <Columns>
            <Column>
              <Stack alignX="left" space="xxsmall">
                <Text
                  variant="subtitle-small"
                  weight="medium"
                  tone="neutral"
                  data-id="my-cart-fee-name"
                >
                  {content.equipmentFee}
                </Text>
                <Text
                  variant="body-small"
                  weight="regular"
                  data-id="my-cart-fee-unit"
                >
                  {content.equipmentFeeUnit}
                </Text>
                <Text
                  variant="body-small"
                  weight="regular"
                  data-id="my-cart-fee-description"
                >
                  {content.equipmentFeeDescription}
                </Text>
              </Stack>
            </Column>
            <Column alignX="right" width="content">
              <Stack alignX="right" space="xxsmall">
                <Text
                  variant="subtitle-small"
                  weight="medium"
                  tone="neutral"
                  data-id="my-cart-fee"
                >
                  $
                  {offer.equipmentFee &&
                    formatCurrencyAndRoundUp(offer.equipmentFee)}
                </Text>
                <Text variant="body-small" weight="regular" tone="neutral">
                  {content.equipmentFeeQualifier}
                </Text>
              </Stack>
            </Column>
          </Columns>
        </Stack>
      </Stack>
    </Card>
  );
};
